/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_VIRTUALLOBBY (state, virtuallobbys) {
    state.virtuallobbys = virtuallobbys
  },
  REMOVE_RECORD (state, itemId) {
    const virtuallobbyIndex = state.virtuallobbys.findIndex((u) => u.Email === itemId)
    state.virtuallobbys.splice(virtuallobbyIndex, 1)
  }
}
